import React from "react";
import { Button } from "@mui/material";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

import "./LogoutButton.scss";
import { bifrost } from "../../../assets/bifrost";
import { Locale } from "../../../assets/Locale";

export const LogoutButton = (props)=>{
    const { children } = props;
    const say = Locale.use();

    const onClick = _=>bifrost.tx("/me/logout");

    return (
        <Button
            className="BlimpMuiPanel-action LogoutButton"
            onClick={onClick}
            startIcon={<LogoutOutlinedIcon />}
            type="button"
            variant="outlined"
        >
            {children || say("userLogout")}
        </Button>
    );
};
